import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=47a3f309&scoped=true&"
import script from "./HeaderComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=47a3f309&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a3f309",
  null
  
)

export default component.exports